export const CHOOSE_MAKER = "CHOOSE_MAKER";
export const CHOOSE_MODEL = "CHOOSE_MODEL";
export const CHOOSE_POWER_MAX = "CHOOSE_POWER_MAX";
export const CHOOSE_POWER_MIN = "CHOOSE_POWER_MIN";
export const CHOOSE_YEAR_MAX = "CHOOSE_YEAR_MAX";
export const CHOOSE_YEAR_MIN = "CHOOSE_YEAR_MIN";
export const CHOOSE_PRICE_MAX = "CHOOSE_PRICE_MAX";
export const CHOOSE_PRICE_MIN = "CHOOSE_PRICE_MIN";
export const SORT_PRICE = "SORT_PRICE";
export const CHOOSE_ID = "CHOOSE_ID";
